<template>
  <Dialog
    v-model:visible="visibleDialog"
    :style="{ width: '680px' }"
    :header="'Finalizar Solicitação #' + obj.id"
    :modal="true"
    class="p-fluid"
    @hide="hideDialog"
  >
    <TabPanel>
      <Card class="col-12">
        <template #content>
          <text-details :objSelected="objSelected" />
        </template>
      </Card>
      <br />
      <div class="fluid">
        <div class="field">
          <label for="operator">Operador</label>
          <Dropdown
            id="operator"
            :options="operators"
            optionLabel="name"
            optionValue="id"
            placeholder="Selecione o operador"
            :showClear="true"
            :filter="true"
            v-model="operatorSelected"
          >
          </Dropdown>
        </div>
      </div>
      <br />
      <div class="field">
        <Textarea
          v-model="obj.diagnose"
          placeholder="Descreva a sua solução para o problema"
          rows="3"
          :autoResize="true"
        />
      </div>
      <hr />
      <div class="field">
        <FileUpload
          mode="basic"
          name="demo[]"
          accept="application/pdf"
          :maxFileSize="2000000"
          @select="onSelect"
        />
      </div>
      <ProgressBar mode="indeterminate" v-if="initProgress" />
      <hr />
    </TabPanel>
    <template #footer>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        @click="hideDialog"
        class="p-button-text"
      />
      <Button
        label="Enviar"
        icon="pi pi-check"
        @click="onUpload"
        :disabled="disableSend"
      />
    </template>
  </Dialog>
</template>

<script>
//Models
import Solicitation from "../../../models/internal/solicitation";

//Services
import SolicitationService from "../../../service/solicitation/solicitation_service";
import OperatorService from "../../../service/operator/operator_service";

//Components
import TextDetails from "../../../components/solicitation/text-details.vue";

export default {
  props: ["objSelected"],
  components: { TextDetails },
  data() {
    return {
      service: new SolicitationService(),
      operatorService: new OperatorService(),
      obj: new Solicitation(),
      operators: [],
      operatorSelected: null,
      fileSelected: null,
      initProgress: false,
    };
  },
  computed: {
    visibleDialog: {
      get() {
        let value =
          this.$store.state.views.solicitation.finalize.dialogAttending;
        if (value) this.getData();
        return value;
      },
      set(value) {
        this.$store.state.views.solicitation.finalize.dialogAttending = value;
      },
    },
    disableSend() {
      if (!this.obj.diagnose || this.initProgress) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.findUsers();
  },
  methods: {
    getData() {
      this.obj = this.objSelected;
    },
    findUsers() {
      this.operatorService.findActive().then((data) => {
        this.operators = data;
      });
    },
    //TODO: Upload com firebase
    onSelect(obj) {
      this.$Firebase
        .onSelect(obj)
        .then((file) => {
          this.fileSelected = file;
        })
        .catch((err) => {
          this.$toast.add({
            severity: "error",
            summary: "Erro!",
            detail: err,
            life: 3000,
          });
        });
    },
    onUpload() {
      if (this.fileSelected !== null) {
        this.initProgress = true;
        this.$Firebase
          .onUpload(this.fileSelected, `os/${this.obj.id}`)
          .then((url) => {
            this.obj.url = url;
            this.finish();
          })
          .catch((err) => {
            console.error(err);
            this.initProgress = false;
            this.$toast.add({
              severity: "error",
              summary: "Alerta de Erro.",
              detail: "Não foi possível enviar a imagem, tente novamente!",
              life: 6000,
            });
          });
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Alerta de Erro.",
          detail: "Selecione um arquivo para upload!",
          life: 6000,
        });
      }
    },
    finish() {
      this.service
        .finish(
          this.obj.id,
          this.operatorSelected,
          this.obj.diagnose,
          this.obj.url
        )
        .then((res) => {
          if (res.status === 200) {
            this.$toast.add({
              severity: "success",
              summary: "Alerta!",
              detail: "Solicitação finalizada com sucesso!",
              life: 3000,
            });
            this.hideDialog();
          }
        })
        .catch((error) => {
          this.initProgress = false;
          this.$msgErro(error);
        });
    },
    // TODO: Upload com Storage
    // onSelect(obj) {
    //   this.fileSelected = obj.files[0];
    // },
    // finish() {
    //   if (this.fileSelected === null) {
    //     this.$toast.add({
    //       severity: "error",
    //       summary: "Alerta!",
    //       detail: "Selecione um arquivo PDF!",
    //       life: 3000,
    //     });
    //   } else {
    //     this.service
    //       .finish(
    //         this.obj.id,
    //         this.operatorSelected,
    //         this.obj.diagnose,
    //         this.fileSelected
    //       )
    //       .then((res) => {
    //         if (res.status === 200) {
    //           this.$toast.add({
    //             severity: "success",
    //             summary: "Alerta!",
    //             detail: "Solicitação finalizada com sucesso!",
    //             life: 3000,
    //           });
    //           this.hideDialog();
    //         }
    //       })
    //       .catch((error) => this.$msgErro(error));
    //   }
    // },
    hideDialog() {
      this.initProgress = false;
      this.visibleDialog = false;
      this.obj = new Solicitation();
      this.operatorSelected = null;
      this.$emit("findAll");
    },
  },
};
</script>

<style></style>
